import React, { useState } from "react";
import {
    AppBar,
    Toolbar,
    Box,
    IconButton,
    Button,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    Typography,
    useTheme,
    useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { NavLink } from "react-router-dom";

const navItems = [
    { label: "Home", path: "/" },
    { label: "About", path: "/about" },
    { label: "Solutions", path: "/solutions" },
    { label: "AIOS", path: "https://aios.swancreate.com" },
    { label: "Districts", path: "/districts" },
    { label: "White Papers", path: "/white-papers" },
    { label: "Testimonials", path: "/testimonials" },
    { label: "Gallery", path: "/gallery" },
    { label: "Careers", path: "/careers" },
    { label: "Contact", path: "/contact" },
    { label: "Login", path: "/admin/login" },
];

export default function Topbar() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const [drawerOpen, setDrawerOpen] = useState(false);

    const linkStyle = {
        color: "#fff",
        textTransform: "none",
        fontSize: "1.125rem",
        fontWeight: 600,
        margin: theme.spacing(0, 1),
        "&.active": {
            borderBottom: `3px solid ${theme.palette.secondary.main}`,
        },
        "&:hover": {
            filter: "brightness(1.2)",
        },
        transition: "all 150ms ease-in-out",
    };

    return (
        <>
            <AppBar
                position="sticky"
                elevation={6}
                sx={{
                    background: "linear-gradient(90deg, #003366 0%, #00CFFE 100%)",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                }}
            >
                <Toolbar sx={{ justifyContent: "center", position: "relative" }}>
                    {isMobile && (
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            onClick={() => setDrawerOpen(true)}
                            sx={{ position: "absolute", left: theme.spacing(1) }}
                            className="haptic-press"
                        >
                            <MenuIcon fontSize="large" />
                        </IconButton>
                    )}

                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flex: 1,
                        }}
                    >
                        {!isMobile &&
                            navItems.map((item) =>
                                item.path.startsWith("http") ? (
                                    <Button
                                        key={item.path}
                                        component="a"
                                        href={item.path}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        sx={linkStyle}
                                        className="haptic-press"
                                    >
                                        {item.label}
                                    </Button>
                                ) : (
                                    <Button
                                        key={item.path}
                                        component={NavLink}
                                        to={item.path}
                                        exact={item.path === "/"}
                                        sx={linkStyle}
                                        className="haptic-press"
                                    >
                                        {item.label}
                                    </Button>
                                )
                            )}
                    </Box>
                </Toolbar>
            </AppBar>

            {/* Mobile Drawer */}
            <Drawer
                anchor="left"
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
            >
                <Box
                    sx={{ width: 250, backgroundColor: theme.palette.primary.main, height: "100%" }}
                    role="presentation"
                    onClick={() => setDrawerOpen(false)}
                >
                    <List>
                        {navItems.map((item) => (
                            <ListItem key={item.path} disablePadding>
                                <ListItemButton
                                    component={item.path.startsWith("http") ? "a" : NavLink}
                                    {...(item.path.startsWith("http")
                                        ? { href: item.path, target: "_blank", rel: "noopener noreferrer" }
                                        : { to: item.path, exact: item.path === "/" }
                                    )}
                                    sx={{
                                        color: "#fff",
                                        "&.active .MuiListItemText-root": {
                                            fontWeight: 700,
                                        },
                                    }}
                                    className="haptic-press"
                                >
                                    <Typography variant="h6">{item.label}</Typography>
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>
                </Box>
            </Drawer>
        </>
    );
}
